<!--
 * @Author: qinzhang14
 * @Date: 2021-11-29 19:06:47
 * @LastEditTime: 2021-11-29 19:15:39
 * @LastEditors: qinzhang14
 * @Description: 公共容器
 * @FilePath: \teaching-web\src\views\manage\baseContainer.vue
-->
<template>
  <div class="base-container">
    <div class="title">{{title}}</div>
    <div class="container">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: ''
      },
    },
  }
</script>

<style lang="less" scoped>
.base-container{
  margin: 0 auto;
  padding: 0px 15px 24px;
  width: 1200px;
  background-color: #fff;
  >.title{
    height: 55px;
    line-height: 55px;
    font-size: 16px;
    font-weight: bold;
    color: #262626;
    border-bottom: 1px solid #F0F1F4;
  }
  >.container{
    padding-top: 16px;
  }
}
</style>
